import { Link } from '@material-ui/core';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import {
  lightColorPalette,
  MetricsEmptyStateDudesOnWave
} from '@linearb/linui-common';

const StyledLink = styled(Link)`
  color: ${lightColorPalette.lbBrightBlue_100};
`;

const MetricsEmptyState = styled(MetricsEmptyStateDudesOnWave)`
  width: 50rem;
  height: 20rem;
`;

const MetricsAllContributorsIsALimitedViewState = ({ onClick }) => {
  return (
    <Flex
      items='center'
      justify='center'
      direction='column'
      width='100%'
      pt='x-x-large'
      data-testid='paidLicenseCTA'
    >
      <MetricsEmptyState />
      <Text size='x-x-large' mb='0.5rem' color='shuttleGray'>
        “All contributors” is a limited view
      </Text>
      <Text size='medium' color='shuttleGray'>
        Select a different dashboard:{' '}
        <StyledLink onClick={() => onClick('Dora')}>DORA Metrics</StyledLink>,{' '}
        <StyledLink onClick={() => onClick('Delivery')}>Delivery</StyledLink>,{' '}
        <StyledLink onClick={() => onClick('Quality')}>Quality</StyledLink> or
        add{' '}
        <StyledLink onClick={() => onClick('newDashboard')}>
          Predefined Dashboard
        </StyledLink>
      </Text>
    </Flex>
  );
};

export default MetricsAllContributorsIsALimitedViewState;
